import ContactForm from "@/components/base/ContactForm";
import ContactInfo from "@/components/base/ContactInfo";

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 min-w-0">
          <ContactForm
            page="Manivelle"
            subject="Nouveau lead Dépan'Volets — Manivelle"
            title="Demandez votre devis gratuit"
            subtitle="Décrivez votre panne de manivelle et nous vous recontactons sous 2 heures avec un devis personnalisé."
            variant="compact"
            showTitle
            placeholder="La manivelle tourne dans le vide, le volet ne monte plus..."
          />
          <ContactInfo variant="light" />
        </div>
      </div>
    </section>
  );
}